import { makeInflect } from "../../utils/makeInflect.js";

export const inflectCharacter = makeInflect("znak", "znaky", "znaků");
